/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertToSerializable } from '@dw/utils';

type TLogMethod = (message: string, data?: any) => void;
interface ILogger {
  error: TLogMethod;
  warn: TLogMethod;
  info: TLogMethod;
  debug: TLogMethod;
}

const stringifyLogData = (data?: any): string => {
  if (!data) {
    return '';
  }

  const serializableObject = convertToSerializable(data);
  return JSON.stringify(serializableObject);
}

export const logger: ILogger = ({
  error: (message: string, data?: any) => {
    const logData = stringifyLogData(data);
    // console.error(message, data);
    console.log(`ERROR: ${message}`, data);
    if (window.newrelic) {
      window.newrelic.noticeError(data && data instanceof Error ? data : message, {
        errorData: logData,
        errorDescription: message
      });
    }
  },
  warn: (message: string, data?: any) => console.warn(message, data),
  info: (message: string, data?: any) => console.info(message, data),
  debug: (message: string, data?: any) => console.debug(message, data),
})